import PropTypes from "prop-types";
import {
  COURSE_TYPE_ONLINE,
  COURSE_TYPE_CLASSROOM,
  COURSE_TYPE_ACTIVITY,
  COURSE_TYPE_COMMON_ACTIVITY,
  COURSE_TYPE_PROGRAM,
} from "./constants";

export const PROP_TYPE_PROGRAM = PropTypes.shape({
  activityId: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
  description: PropTypes.string.isRequired,
  responsible: PropTypes.string.isRequired,
  registerdate: PropTypes.string.isRequired,
  completed: PropTypes.bool.isRequired,
  progress: PropTypes.number.isRequired,
  content: PROP_TYPE_PROGRAM_CONTENT,
});

export const PROP_DEFAULT_PROGRAM = {
  activityId: 1,
  title: "",
  image: "",
  description: "",
  responsible: "",
  registerdate: "2020-01-18",
  completed: 0,
  progress: 0,
  content: [PROP_DEFAULT_PROGRAM_COURSE],
};

export const PROP_TYPE_PROGRAM_CONTENT = PropTypes.arrayOf(
  PropTypes.shape({
    type: PropTypes.oneOf([
      COURSE_TYPE_ONLINE,
      COURSE_TYPE_CLASSROOM,
      COURSE_TYPE_PROGRAM,
      COURSE_TYPE_ACTIVITY,
      COURSE_TYPE_COMMON_ACTIVITY,
    ]).isRequired,
    courseId: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    itemDescription: PropTypes.string,
    stepDescription: PropTypes.string,
    image: PropTypes.string,
    isProgram: PropTypes.bool,
    completed: PropTypes.bool.isRequired,
    order: PropTypes.number,
    personalPlannedCoursesId: PropTypes.number,
    accessDate: PropTypes.string,
    activityId: PropTypes.number.isRequired,
    courseEnds: PropTypes.string,
    courseStarts: PropTypes.string,
    createdDate: PropTypes.string,
    durationHours: PropTypes.number,
    durationMinutes: PropTypes.number,
    lastLoggedIn: PropTypes.string,
    lastLoggedIn2: PropTypes.string,
    personalId: PropTypes.string,
    profileId: PropTypes.number,
    requested: PropTypes.bool,
    trainingCategoryId: PropTypes.number,
    programStepGroupID: PropTypes.number,
    programStepGroupTitle: PropTypes.string,
  }),
);

export const PROP_DEFAULT_PROGRAM_CONTENT = [PROP_DEFAULT_PROGRAM_COURSE];

export const PROP_TYPE_PROGRAM_COURSE = PropTypes.shape({
  type: PropTypes.oneOf([
    COURSE_TYPE_ONLINE,
    COURSE_TYPE_CLASSROOM,
    COURSE_TYPE_PROGRAM,
    COURSE_TYPE_ACTIVITY,
    COURSE_TYPE_COMMON_ACTIVITY,
  ]).isRequired,
  courseId: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  itemDescription: PropTypes.string,
  stepDescription: PropTypes.string,
  image: PropTypes.string,
  isProgram: PropTypes.bool,
  completed: PropTypes.bool.isRequired,
  order: PropTypes.number,
  personalPlannedCoursesId: PropTypes.number,
  accessDate: PropTypes.string,
  activityId: PropTypes.number.isRequired,
  courseEnds: PropTypes.string,
  courseStarts: PropTypes.string,
  createdDate: PropTypes.string,
  durationHours: PropTypes.number,
  durationMinutes: PropTypes.number,
  lastLoggedIn: PropTypes.string,
  lastLoggedIn2: PropTypes.string,
  personalId: PropTypes.string,
  profileId: PropTypes.number,
  requested: PropTypes.bool,
  trainingCategoryId: PropTypes.number,
});

export const PROP_DEFAULT_PROGRAM_COURSE = {
  type: COURSE_TYPE_ONLINE,
  courseId: 5023,
  title: "kurs 1",
  itemDescription: "kurs 1 beskrivning",
  stepDescription: "steg 1",
  image: null,
  completed: true,
  progress: 100,
  order: 1,
  personalPlannedCoursesId: 0,
  accessDate: "0001-01-01T00:00:00",
  activityId: 0,
  assignments: null,
  courseEnds: "2029-11-20T00:00:00",
  courseStarts: "2019-11-20T00:00:00",
  createdDate: "2019-11-20T13:53:17.54",
  durationHours: 0,
  durationMinutes: 0,
  lastLoggedIn: "2020-02-25T08:58:25.467",
  lastLoggedIn2: "0001-01-01T00:00:00",
  personalId: "1C4F7518-6DAD-4573-9E48-218E1EB8E05C",
  profileId: 1,
  requested: false,
  trainingCategoryId: 0,
};
